<nav class="nav-tabs" [class.small]="size() === 'small'">
  @for (tab of tabs(); track $index) {
    @if (tab.href) {
      <a
        class="tab typography-body-regular"
        [class.active]="tab.active"
        [href]="tab.href"
        target="_blank"
        rel="noopener noreferrer"
        [attr.aria-label]="tab.ariaLabel ?? null"
        [attr.aria-controls]="tab.ariaControls ?? null"
        [attr.aria-expanded]="tab.ariaExpanded ?? null"
        [attr.aria-haspopup]="tab.ariaHasPopup ?? null"
        (click)="onClick(tab)"
      >
        <ng-container [ngTemplateOutlet]="content" [ngTemplateOutletContext]="{ $implicit: tab }" />
      </a>
    } @else if (tab.routerLink) {
      <a
        class="tab typography-body-regular"
        [class.active]="tab.active"
        [routerLink]="tab.routerLink"
        [attr.aria-label]="tab.ariaLabel ?? null"
        [attr.aria-controls]="tab.ariaControls ?? null"
        [attr.aria-expanded]="tab.ariaExpanded ?? null"
        [attr.aria-haspopup]="tab.ariaHasPopup ?? null"
        (click)="onClick(tab)"
      >
        <ng-container [ngTemplateOutlet]="content" [ngTemplateOutletContext]="{ $implicit: tab }" />
      </a>
    } @else {
      <button
        type="button"
        class="tab typography-body-regular"
        [class.active]="tab.active"
        [attr.aria-label]="tab.ariaLabel ?? null"
        [attr.aria-controls]="tab.ariaControls ?? null"
        [attr.aria-expanded]="tab.ariaExpanded ?? null"
        [attr.aria-haspopup]="tab.ariaHasPopup ?? null"
        (click)="onClick(tab)"
      >
        <ng-container [ngTemplateOutlet]="content" [ngTemplateOutletContext]="{ $implicit: tab }" />
      </button>
    }
  }
</nav>

<ng-template #content let-tab>
  @if (tab.icon) {
    <span class="icon">
      <app-icon [path]="tab.icon" [size]="iconSize()" />
      @if (tab.dot) {
        <span class="dot" aria-hidden="true"></span>
      }
    </span>
  }
  @if (tab.label) {
    <span class="label">{{ tab.label }}</span>
  }
  @if (tab.chip !== undefined) {
    <span class="chip">{{ tab.chip }}</span>
  }
</ng-template>
